import repairStateFilter from 'app/filters/repairState'

export default class RepairState {

    static PENDING = 'PENDING';
    static RESOLVED = 'RESOLVED';

    static options(){

        return {
            'PENDING': repairStateFilter(RepairState.PENDING),
            'RESOLVED': repairStateFilter(RepairState.RESOLVED)
        };
    }
}